export default __webpack_public_path__ + "static/bg_angel_vaults-c1af67930bbb64cf8e07302fcd5a2f7d.png";